import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  CssBaseline,
  IconButton,
  ThemeProvider,
} from "@material-ui/core";
import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import ToolBarComponent from "./ToolBarComponent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import { Redirect } from "react-router-dom";
import { defaultTheme } from "../utils/theme";
import { grey } from "@material-ui/core/colors";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  toolBarData: any;
  pageTitle: any;
  showCompanies: any;
}
class AppBarComponent extends React.Component<Props> {
  state = { redirect: false };

  onMenuButtonClicked = (type: String) => {
    if (type === "home") {
      this.setState({ redirect: true });
    }
  };
  renderMenuButton = (styleMenuButton: any, type: String) => {
    return (
      <IconButton
        style={{
          alignSelf: "flex-start",
        }}
        aria-label="open drawer"
        edge="start"
        onClick={() => {
          this.onMenuButtonClicked(type);
        }}
        className={styleMenuButton}
      >
        {type === "child" && <ArrowBackIcon />}
        {type === "home" && <HomeIcon style={{ color: grey[500] }} />}
      </IconButton>
    );
  };
  render() {
    const { classes, toolBarData, pageTitle, showCompanies } = this.props;
    return (
      <div className={classes.root}>
        {this.state.redirect && <Redirect to="/segpi/" />}
        <CssBaseline />
        <ThemeProvider theme={defaultTheme}>
          <AppBar position="fixed" className={classes.appBar}>
            {toolBarData && (
              <ToolBarComponent
                title={pageTitle}
                buttonTitle={toolBarData.title}
                onToolBarButtonClicked={toolBarData.callBack}
                menuButtonRender={
                  showCompanies
                    ? this.renderMenuButton(classes.menuShowButton, "home")
                    : toolBarData.callBack
                    ? this.renderMenuButton(classes.menuShowButton, "child")
                    : this.renderMenuButton(classes.menuHideButton, "home")
                }
                additionalButton={toolBarData.additionalToolBarData}
              />
            )}
          </AppBar>
        </ThemeProvider>
      </div>
    );
  }
}
export default withStyles(styles)(AppBarComponent);
